document.addEventListener('DOMContentLoaded', function() {
  // 価格表示を監視して変更
  function fixSubscriptionPrice() {
    const priceElements = document.querySelectorAll('.shopify_subscriptions_in_widget_price');
    
    priceElements.forEach(function(element) {
      const text = element.textContent;
      // "¥3,980 JPY" を "3980円" に変換
      if (text.includes('JPY')) {
        const price = text.replace(/[¥,\s]/g, '').replace('JPY', '');
        element.textContent = price + '円';
      }
    });
  }
  
  // 初回実行
  fixSubscriptionPrice();
  
  // DOM変更を監視（アプリが後から価格を挿入する場合に対応）
  const observer = new MutationObserver(fixSubscriptionPrice);
  observer.observe(document.body, { 
    childList: true, 
    subtree: true 
  });
});